import React, { useState, useEffect } from "react";
import NoteContext from "./noteContext";

const NoteState = (props) => {
  const [state, setState] = useState(null);
  
  const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TRADES}`;
  const handleLogin = async () => {
    const res = await fetch(path);
    const data = await res.json();
    setState(data); // ✅ yaha actual data
  };

  useEffect(() => {
    handleLogin();
  }, []); 

  return (
    <NoteContext.Provider value={state}>{props.children}</NoteContext.Provider>
  );
};

export default NoteState;
